const prod = {
  googleAnalyticsTrackingId: 'G-QCQLM7BJFX',
  mode: 'PRODUCTION',
};

const dev = {
  googleAnalyticsTrackingId: 'G-488FQ6JHZS',
  mode: 'DEVELOPMENT',
};

let gAnalytics;

if (window.location.hostname.includes('test.medbioinformatics.com')) {
  gAnalytics = dev;
} else if (process.env.NODE_ENV === 'development') {
  gAnalytics = dev;
} else {
  gAnalytics = prod;
}

export const citationCount = process.env.REACT_APP_RELEASE_VERSION === 'v253' ? '7.9' : '8.2';

// eslint-disable-next-line no-undef
export { gAnalytics };
